import React from 'react';
import { makeStyles } from 'tss-react/mui';
import brandColors from 'styles/skipper/brandColors';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import { Person } from '@sift/types';
import storage from 'helpers/storage';

interface Props {
  open: boolean;
  proxyAsPerson: Person;
}

function ProxySnackbar({ open, proxyAsPerson }: Props) {
  const { classes } = useStyles();

  const handleCloseProxy = () => {
    storage.removeItem('PROXY_AS_ID');

    setTimeout(() => {
      const url = new URL(window.location.href);

      // Clear the proxyAs parameter if it exists to ensure we are not proxying on reload
      url.searchParams.delete('proxyAs');

      window.location.href = url.toString();
    }, 300);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      message={`You're currently proxying as ${proxyAsPerson.displayName}`}
      action={
        <Button onClick={handleCloseProxy} className={classes.button}>
          Stop Proxy View
        </Button>
      }
    />
  );
}

const useStyles = makeStyles()(theme => {
  return {
    root: {},
    button: {
      color: brandColors.indicatorColors.gold,
    },
  };
});

export default ProxySnackbar;
